import MobileDetect from 'mobile-detect'

let md = new MobileDetect(navigator.userAgent)

export const isMobile = md.mobile()

export const isIPad = navigator.userAgent.search(/iPad/) > -1
export const isIPhone = navigator.userAgent.search(/iPhone/) > -1
export const isLowPerformance = !navigator.hardwareConcurrency || navigator.hardwareConcurrency <= 4

// Reliable phone detection: works even when Safari "Request Desktop Website" rewrites the UA.
// Math.min handles landscape mode where screen.width reports the larger dimension.
const _isWindows = /Windows/.test(navigator.userAgent);
const _touchSmallScreen = !_isWindows && navigator.maxTouchPoints > 1 && Math.min(window.screen.width, window.screen.height) < 768;

export const isPhoneDevice = (
  (isMobile || isIPhone || _touchSmallScreen)
  && !isIPad
);

console.log("[platform]", {
  ua: navigator.userAgent.substring(0, 120),
  isMobile, isIPhone, isIPad, isPhoneDevice,
  maxTouchPoints: navigator.maxTouchPoints,
  screenW: window.screen.width,
  screenH: window.screen.height,
  minScreen: Math.min(window.screen.width, window.screen.height),
  _touchSmallScreen,
});

export const isInMobileApp = window.navigator ?
  window.navigator.userAgent.includes('nya-mobile') : false;

export const isInIOSApp = window.navigator ?
  window.navigator.userAgent.includes('nya-mobile-ios') : false;
